import React from "react";
import img from "../../Image/fLogo.png";
import { Link } from "react-router-dom";
import { FaUser } from "react-icons/fa";

const Header = () => {
  const userType = localStorage.getItem("userType");

  return (
    <header className=" bg-white shadow-sm z-50 px-6 py-3" >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/home-page" className="group">
            <img 
              src={img} 
              alt="Logo" 
              className="h-24 w-auto transform transition-transform duration-300 group-hover:scale-105" 
            />
          </Link>
        </div>

        {userType !== "admin" && (
          <div className="flex items-center">
            <Link 
              to="/manager-profile" 
              className="relative group"
            >
              <div className="bg-gray-50 rounded-full p-2.5 transition-all duration-300 group-hover:bg-gray-100 group-hover:shadow-md">
                <FaUser 
                  size={22} 
                  className="text-gray-600 group-hover:text-mainColor transition-colors duration-300" 
                />
              </div>
              <span className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                الملف الشخصي
              </span>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
